import styled from 'styled-components';

export const MachineViewContainer = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100%;
  grid-gap: inherit;
  position: relative;
  .nav-item {
    margin-top: 0;
  }
`;
